import { render, staticRenderFns } from "./QueenDetail.vue?vue&type=template&id=319c93c6&scoped=true&"
import script from "./QueenDetail.vue?vue&type=script&lang=js&"
export * from "./QueenDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319c93c6",
  null
  
)

export default component.exports